export const servicesLastUpdatedEn = "Apr 5, 2025"
export const servicesLastUpdatedRu = "5 апреля, 2025"

export const handbookLastUpdated = "FEB 7, 2025"
export const publicationsLastUpdated = "FEB 7, 2025"
export const softwareLastUpdated = "FEB 7, 2025"
export const musicLastUpdated = "FEB 7, 2025"
export const courseLastUpdated = "FEB 7, 2025"
export const talksLastUpdated = "FEB 7, 2025"
export const goalsLastUpdated = "FEB 7, 2025"
export const explorationLastUpdated = "FEB 7, 2025"
export const freelanceLastUpdated = "JULY 13, 2025"
export const cvLastUpdated = "FEB 7, 2025"
export const aboutLastUpdated = "FEB 7, 2025"
export const feedLastUpdated = "FEB 7, 2025"
export const galleryLastUpdated = "FEB 7, 2025"
export const storiesLastUpdated = "FEB 7, 2025"
export const playlistsLastUpdated = "FEB 7, 2025"
export const albumsLastUpdated = "FEB 7, 2025"
export const filmsLastUpdated = "FEB 7, 2025"
export const bookshelfLastUpdated = "FEB 7, 2025"
export const hallOfFameLastUpdated = "FEB 7, 2025"
export const gearLastUpdated = "FEB 7, 2025"
export const zettelkastenLastUpdated = "FEB 7, 2025"
export const calisthenicsLastUpdated = "FEB 7, 2025"
export const friendsLastUpdated = "FEB 7, 2025"
export const articlesLastUpdated = "FEB 7, 2025"
export const websitesLastUpdated = "FEB 7, 2025"
export const videosLastUpdated = "FEB 7, 2025"
export const habitsLastUpdated = "FEB 7, 2025"
export const faqLastUpdated = "FEB 7, 2025"

export const footerYear = "2026"